module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: ['fixed bottom-0 inset-x-0 bg-white px-4 py-1 flex items-center justify-around z-50 shadow-lg !border-t !border-gray-200 transition-all duration-10', {
      'translate-y-full opacity-0 pointer-events-none': _vm.isKeyboardOpen
    }]
  }, [_c('router-link', {
    staticClass: "flex flex-col items-center text-gray-600",
    attrs: {
      "to": "/home"
    }
  }, [_c('i', {
    staticClass: "inline-block h-10 w-10 mask mask-home bg-secondary"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-md text-secondary"
  }, [_vm._v("Accueil")])]), _vm._v(" "), _c('span', {
    staticClass: "relative flex items-center justify-center w-24 h-24 bg-white rounded-full -mt-14 shadow-lg"
  }, [_c('router-link', {
    staticClass: "flex flex-col items-center justify-center bg-primary w-20 h-20 rounded-full shadow-lg",
    attrs: {
      "to": {
        name: 'otag'
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-14 w-14 mask mask-otag bg-white -mb-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-md text-white leading-none"
  }, [_vm._v("Scan")])])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex flex-col items-center text-gray-600",
    attrs: {
      "to": {
        name: 'support'
      },
      "id": "btnBottomSupport"
    }
  }, [_c('i', {
    staticClass: "inline-block h-10 w-10 mask mask-question bg-secondary"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-md text-secondary"
  }, [_vm._v("Support")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d7dfa46","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BottomMenu.vue
// module id = 1034
// module chunks = 0